import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import {
  Button,
  ButtonGroup,
  OverlayTrigger,
  Table,
  Tooltip,
} from 'react-bootstrap';
import { ContextMenuTrigger, ContextMenu } from 'react-contextmenu';
import { format } from 'date-fns';
import TextButton from '../ui/TextButton';
import ListViewIcon from '../../../icons/sub-menu-and-common-icons/list-view.svg';
import GridView1 from '../../../icons/sub-menu-and-common-icons/tile-view1.svg';
import { MetaInput } from './MetaInput';
import Error from '../Icons/Error';
import CheckIcon from '../Icons/CheckIcon';
import { getJobStatus, uploadFileWithMetaData } from './HttpServices';
import Loader from '../ui/Loader';
import { DATE, RGROUP, SINGLE_REPEATING_FIELD } from './MetaInput/MetaTypes';
import { CustomContextMenu } from './ContexMenu';
import {
  ALL_END_JOB_STATUS,
  COPY_CELL_DOWNWARDS,
  COPY_CELL_UPWARDS,
  COPY_ROW_DOWNWARDS,
  COPY_ROW_UPWARDS,
  DUPLICATE_RECORD_FILE_STATUS,
  FAILED_JOB_STATUS,
  FINISHED_JOB_STATUS,
  LOADING_STATUS,
  PAUSED_JOB_STATUS,
  IMAGE_FILE_TYPES,
  STOPPED_JOB_STATUS,
  SUCCESS_JOB_STATUS,
  TOAST_TYPE,
  DOCUMENT_FILE_TYPES,
  VIDEO_FILE_TYPES,
  AUDIO_FILE_TYPES,
} from './constants';
import { updateMetaData } from '../BulkMetaEdit/httpServices';
import CloseOval from '../Icons/CloseOval';
import {
  isFileUploaderUploading,
  showSearchAsMain,
  showUMOGridNoJView,
} from '../../actions/mainUI';
import { deselectAll } from '../../actions/umoGallery';
import { DATE_FORMAT } from '../../constants/session';
import appConfig from '../../appConfig';
import {
  formatBytes,
  trimFileName,
  getThumbnail,
  isThumbnailAvailable,
  getFileExtension,
} from './utils';
import { retrieveCategoryIndicator } from '../../actions/categories';
import { toast } from 'react-toastify';
function FilesList({
  imageList,
  onImageRemoveAll,
  onImageUpdate,
  onImageRemove,
  setIsDropAreaVisible,
  metaTags,
  maxFileSize,
  hstPath,
  categoryIdToUpload,
  surl,
  csrf,
  isUploading,
  setIsUploading,
  completedApiCount,
  setCompletedApiCount,
  setIsError,
  setIsFilesUploaded,
  metaValues,
  setMetaValues,
  showToast,
  setIsJobProcessing,
  isJobProcessing,
  isAllJobsFinished,
  setIsAllJobsFinished,
  //meta-edit
  showMetaEditVersion,
  searchResults,
  homeScreenRefresh,
  //loading-indicator
  setIsUploadingIndicatorShown,
  setFilesLoadingStatus,
  intl,
}) {
  const [isMetaView, setIsMetaView] = useState(false);
  const [tagsWithUserInput, setTagsWithUserInput] = useState([]);
  const [isTotalFileSizeExceeded, setIsTotalFileSizeExceeded] = useState(false);
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [bulkUploadUserInput, setBulkUploadUserInput] = useState([]);
  const [isMetaEditValuesUpdated, setIsMetaEditValuesUpdated] = useState(false);
  const [onContextFileIndex, setOnContextFileIndex] = useState(null);
  const [onContextTagIndex, setOnContextTagIndex] = useState(null);
  const [hasTriedSubmitting, setHasTriedSubmitting] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const allJobsCount = isAllJobsFinished.reduce(
      (accumulator, currentValue) => accumulator + (currentValue ? 1 : 0),
      0
    );
    if (allJobsCount === imageList.length && isJobProcessing) {
      setIsJobProcessing(false);
      setIsFilesUploaded(true);
    }
  }, [isAllJobsFinished]);

  useEffect(() => {
    setupMetaTagsWithUserInput();
  }, [metaTags, categoryIdToUpload]);

  const handleInputChange = (
    rowIndex,
    colIndex,
    newValue,
    isSingleRepeatingFeild = false
  ) => {
    //rowIndex is the index of the file
    //rowIndex length is the length of no of files
    //colIndex is the index of the respective meta tag of the file
    //colIndex length is the no of meta tags a file has
    const updateMetaState = (prevGridData) => {
      const newGridData = [...prevGridData];
      newGridData[rowIndex] = [...newGridData[rowIndex]];
      if (isSingleRepeatingFeild) {
        newGridData[rowIndex][colIndex] = {
          ...newGridData[rowIndex][colIndex],
          meta: {
            ...newGridData[rowIndex][colIndex].meta,
            userInput: Array.isArray(
              newGridData[rowIndex][colIndex].meta.userInput
            )
              ? [newValue]
              : [...newGridData[rowIndex][colIndex].meta.userInput, newValue],
          },
        };
      }
      newGridData[rowIndex][colIndex] = {
        ...newGridData[rowIndex][colIndex],
        meta: {
          ...newGridData[rowIndex][colIndex]?.meta,
          userInput: newValue,
        },
      };
      return newGridData;
    };
    if (isBulkUpload) setBulkUploadUserInput(updateMetaState);
    else setMetaValues(updateMetaState);
  };

  useEffect(() => {
    // it will calculate the total size of the all files to be uploaded
    // and update error state if it exceeds the maxFileSizeForUpload
    // if it is in Upload view
    if (!showMetaEditVersion) {
      let totalFileSize = 0;
      if (imageList && imageList.length > 0) {
        totalFileSize = imageList.reduce(
          (accumulator, file) => accumulator + file.file.size,
          0
        );
      }
      setIsTotalFileSizeExceeded(totalFileSize > maxFileSize);
    }
  }, [imageList]);

  const updateMetaValuesTags = () => {
    //initiating meta tags with userInput value
    setMetaValues((prevMetaValues) => {
      if (imageList.length > prevMetaValues.length) {
        let differenceInLength = imageList.length - prevMetaValues.length;
        let temp = [...prevMetaValues];
        for (let i = 0; i < differenceInLength; i++) {
          temp.push(tagsWithUserInput);
        }
        return temp;
      }
      return prevMetaValues;
    });
  };

  //Update meta values when new image is added
  useEffect(() => {
    updateMetaValuesTags();
  }, [imageList.length]);

  //Resets meta values when category ID changes
  useEffect(() => {
    setMetaValues([]);
    setCompletedApiCount([]);
    updateMetaValuesTags();
  }, [categoryIdToUpload]);

  const setupMetaTagsWithUserInput = () => {
    let temp = metaTags;
    for (let i = 0; i < temp.length; i++) {
      temp[i].meta.userInput = '';
    }
    setTagsWithUserInput(temp);
    setBulkUploadUserInput([temp]);
  };

  useEffect(() => {
    if (
      showMetaEditVersion &&
      searchResults.length > 0 &&
      metaValues.length > 0 &&
      !isMetaEditValuesUpdated
    ) {
      updateMetaValuesWithExistingValue();
    }
  }, [showMetaEditVersion, searchResults, metaValues]);

  const findAllIndicesWithSameId = (array, id) => {
    return array.reduce((indices, element, index) => {
      if (element.id === id) {
        indices.push(index);
      }
      return indices;
    }, []);
  };

  const updateMetaValuesWithExistingValue = () => {
    if (
      searchResults.length > 0 &&
      metaValues.length > 0 &&
      !isMetaEditValuesUpdated
    ) {
      EachUMOLoop: searchResults.map((result, fileIndex) => {
        let updatedSingleRepeatingFields = [];
        UMOMetaValueLoop: result?.m.map((metaData, metaDataIndex) => {
          let metaValueIndex = metaValues[fileIndex].findIndex(
            (currentValue) => {
              return currentValue.meta.id == metaData.id;
            }
          );
          if (metaData.t != RGROUP && metaData.rf == SINGLE_REPEATING_FIELD) {
            if (updatedSingleRepeatingFields.includes(metaData.id)) return;
            else {
              let repeatingFieldIndices = findAllIndicesWithSameId(
                result.m,
                metaData.id
              );
              let srfValues = [];
              for (let i = 0; i < repeatingFieldIndices.length; i++) {
                srfValues.push(result.m[repeatingFieldIndices[i]].v);
              }
              updatedSingleRepeatingFields.push(metaData.id);
              handleInputChange(fileIndex, metaValueIndex, srfValues);
              return;
            }
          } else if (metaData.t === RGROUP) {
            let maxP = 1;
            metaData.rgroup.map((rgroup) => {
              if (parseInt(rgroup.p) > maxP) maxP = parseInt(rgroup.p);
            });
            let repeatingGroupValue = new Array(maxP);
            for (let i = 0; i < repeatingGroupValue.length; i++)
              repeatingGroupValue[i] = new Array();
            metaData.rgroup.map((rgroup) => {
              if (repeatingGroupValue.length >= parseInt(rgroup.p)) {
                // Ensure repeatingGroupValue[parseInt(rgroup.p) - 1] is initialized as an array
                let positionIndex = parseInt(rgroup.p) - 1;
                if (
                  !Array.isArray(repeatingGroupValue[parseInt(rgroup.p) - 1])
                ) {
                  repeatingGroupValue[positionIndex] = [];
                }
                repeatingGroupValue[positionIndex].push({
                  tagName: rgroup.c,
                  tagId: rgroup.id,
                  userInput: rgroup.v,
                  position: rgroup.p,
                });
              }
            });
            handleInputChange(fileIndex, metaValueIndex, repeatingGroupValue);
            return;
          } else if (metaData.t === DATE) {
            handleInputChange(
              fileIndex,
              metaValueIndex,
              metaData.v
                ? new Date(metaData.v?.split(' ')[0])
                : null
            );
          } else handleInputChange(fileIndex, metaValueIndex, metaData.v);
        });
      });
      setIsMetaEditValuesUpdated(true);
    }
  };

  const removeImage = (index) => {
    onImageRemove(index);
    setMetaValues((prevMetaValues) => {
      let temp = [...prevMetaValues];
      temp.splice(index, 1);
      return temp;
    });
  };

  const validateForm = async () => {
    for (let fileIndex in imageList) {
      const currentFileMeta = isBulkUpload
        ? bulkUploadUserInput[0] //bulk upload user input for all imageList[fileIndex]
        : metaValues[fileIndex]; //metaValues[fileIndex] is the metaValues of imageList[fileIndex]

      for (let metaValue of currentFileMeta) {
        let isMandatory = metaValue.attributes.mandatory == 'T';
        let type = metaValue?.meta?.type;
        let isRepeatingField =
          type === RGROUP || type === SINGLE_REPEATING_FIELD ? true : false;
        let input = metaValue.meta.userInput;
        if (isRepeatingField && isMandatory) {
          if (
            !Array.isArray(input) ||
            (Array.isArray(input) && input?.length === 0)
          ) {
            toast.error(
              intl.formatMessage({ id: 'fileUploader.requiredMetadataError' })
            );
            return false;
          }
        }
        if (isMandatory && input != null && input?.length === 0) {
          toast.error(
            intl.formatMessage({ id: 'fileUploader.requiredMetadataError' })
          );
          return false;
        }
      }
    }
    return true;
  };

  const onClickUpload = async () => {
    setHasTriedSubmitting((prevValue) => prevValue + 1);
    let isFormValid = await validateForm();
    if (!isFormValid) return;
    const DEFAULT_BATCH_SIZE = 2;
    const DEFAULT_TIMEOUT_DELAY = 2000;
    const DEFAULT_UPLOAD_TYPE = 'BATCH';

    const TIMEOUT_DELAY =
      appConfig.fileUploader?.timeDelay ?? DEFAULT_TIMEOUT_DELAY;
    const UPLOAD_TYPE =
      appConfig.fileUploader?.uploadType ?? DEFAULT_UPLOAD_TYPE;

    const BATCH_SIZE =
      UPLOAD_TYPE === 'BATCH'
        ? appConfig.fileUploader?.batchSize ?? DEFAULT_BATCH_SIZE
        : imageList.length;

    dispatch(isFileUploaderUploading(true));
    setIsUploading(true);
    setIsJobProcessing(true);
    setIsFilesUploaded(false);
    setCompletedApiCount(Array(imageList.length).fill(false));
    setIsAllJobsFinished(Array(imageList.length).fill(false));
    setIsUploadingIndicatorShown(true);
    setFilesLoadingStatus(Array(imageList.length).fill(LOADING_STATUS.QUEUED));
    for (let i = 0; i < imageList.length; i += BATCH_SIZE) {
      const batch = Array.from(
        { length: BATCH_SIZE } /** Size of the batch */,
        (_, j) =>
          i +
          j /** Calculates each element in the array as i+j, i starts with the batch size every iteration */
      ).filter(
        (index) => index < imageList.length
      ); /** Filter out elements that are greater than the imageList.length */
      let allFileUploadJobs = [];
      await uploadBatch(batch, allFileUploadJobs);
      if (!Array.isArray(allFileUploadJobs) || allFileUploadJobs.length === 0) {
        showToast(intl.formatMessage({ id: 'fileUploader.fileUploadFail' }));
        setIsUploading(false);
        return;
      }

      await checkJobStatusInBatches(
        allFileUploadJobs,
        BATCH_SIZE,
        TIMEOUT_DELAY,
        batch
      );
    }
    setIsUploading(false);
    dispatch(isFileUploaderUploading(false));
    setIsJobProcessing(false);
    setIsFilesUploaded(true);
    dispatch(retrieveCategoryIndicator(categoryIdToUpload));
  };

  /**Checks Job status of all file uploas in batches on loop with a TIME_OUT delay
   * untill a success or failure response received */
  const checkJobStatusInBatches = async (
    allFileUploadJobs,
    BATCH_SIZE,
    TIMEOUT_DELAY,
    LOADING_BATCH
  ) => {
    const processBatch = async (batch) => {
      await Promise.all(
        batch.map(({ job, index }) =>
          checkJobStatus(job, index, TIMEOUT_DELAY, LOADING_BATCH)
        )
      );
    };

    for (let i = 0; i < allFileUploadJobs.length; i += BATCH_SIZE) {
      const batch = allFileUploadJobs
        .slice(i, i + BATCH_SIZE) //Slicing jobs in batch sizes
        .map((job, index) => ({ job, index: i + index })); //mapping through the sliced job array
      await processBatch(batch);
    }
  };

  const checkJobStatus = (job, index, TIMEOUT_DELAY, LOADING_BATCH) => {
    // job
    // [0] jobData.job_id,
    // [1] jobData.loader_id,
    // [2] file.name,
    // [3] imageList[fileIndex].fileId,
    return new Promise((resolve, reject) => {
      const pollStatus = () => {
        getJobStatus(
          hstPath,
          surl,
          csrf,
          job[0], // job_id
          job[1] // loader_id
        )
          .then((res) => {
            if (
              res.status == 200 &&
              Array.isArray(res.data) &&
              res.data[0]?.status
            ) {
              const jobStatus = res.data[0]?.status?.toLowerCase();
              const duplicated = res.data[0]?.duplicated?.toLowerCase();
              if (ALL_END_JOB_STATUS.includes(jobStatus)) {
                if (
                  jobStatus === SUCCESS_JOB_STATUS ||
                  (jobStatus === FINISHED_JOB_STATUS && res.data[0].succ === 1)
                ) {
                  // succeeded
                  if (job && job.length > 3 && job[3]) {
                    updateIsJobFinshedAt(job[3]);
                    updateLoadingStatusAt(job[3], LOADING_STATUS.UPLOADED);
                  }
                  resolve();
                } else if (
                  [PAUSED_JOB_STATUS, STOPPED_JOB_STATUS].includes(jobStatus)
                ) {
                  // job stopped
                  if (job && job.length > 3) {
                    updateIsJobFinshedAt(job[3]);
                    updateLoadingStatusAt(job[3], LOADING_STATUS.FAILED);
                  }
                  resolve();
                } else if (
                  jobStatus == FAILED_JOB_STATUS &&
                  duplicated == DUPLICATE_RECORD_FILE_STATUS
                ) {
                  if (job && job.length > 3) {
                    updateIsJobFinshedAt(job[3]);
                    updateLoadingStatusAt(
                      job[3],
                      LOADING_STATUS.FAILED_DUPLICATED
                    );
                  }
                  resolve();
                } else {
                  // job failed
                  if (job && job.length > 3) {
                    updateIsJobFinshedAt(job[3]);
                    updateLoadingStatusAt(job[3], LOADING_STATUS.FAILED);
                  }
                  resolve();
                }
              } else {
                setTimeout(pollStatus, TIMEOUT_DELAY);
              }
            } else {
              if (job && job.length > 3) {
                if (job && job.length > 3) {
                  updateIsJobFinshedAt(job[3]);
                  updateLoadingStatusAt(job[3], LOADING_STATUS.FAILED);
                }
                resolve();
              }
            }
          })
          .catch((errors) => {
            console.log('Post processing check failed for: ', job[2], errors);
            if (job && job.length > 3) {
              updateIsJobFinshedAt(job[3]);
              updateLoadingStatusAt(job[3], LOADING_STATUS.FAILED);
            }
            resolve();
          });
      };
      pollStatus();
    });
  };

  const uploadBatch = async (batch, fileUploadJobs) => {
    let fileUploadPromises = [];
    fileLoop: batch.forEach((fileIndex) => {
      updateLoadingStatusAt(
        imageList[fileIndex].fileId,
        LOADING_STATUS.UPLOADING
      );
      let metaValuesParams = '';
      const currentFileMeta = isBulkUpload
        ? bulkUploadUserInput[0] //bulk upload user input for all imageList[fileIndex]
        : metaValues[fileIndex]; //metaValues[fileIndex] is the metaValues of imageList[fileIndex]
      metaValuesLoop: for (let j = 0; j < currentFileMeta.length; j++) {
        const metaName = currentFileMeta[j]?.meta?.name;
        const userInput = currentFileMeta[j]?.meta?.userInput;
        const metaType = currentFileMeta[j]?.meta?.type;
        const isEmptyMetaTag =
          !userInput ||
          userInput == '' ||
          (Array.isArray(userInput) && userInput.length == 0);

        if (isEmptyMetaTag) continue metaValuesLoop;
        else {
          if (metaType === RGROUP) {
            //RGROUP
            userInput.forEach((group) => {
              group.forEach((tag) => {
                metaValuesParams =
                  metaValuesParams +
                  '&' +
                  encodeURIComponent(tag.tagName) +
                  '=' +
                  encodeURIComponent(tag.userInput);
              });
            });
          }
          //For single repeating input
          else if (Array.isArray(userInput) && userInput.length > 0) {
            userInput.forEach((input) => {
              metaValuesParams =
                metaValuesParams +
                '&' +
                encodeURIComponent(metaName) +
                '=' +
                encodeURIComponent(input);
            });
          } else
            metaValuesParams =
              metaValuesParams +
              '&' +
              encodeURIComponent(metaName) +
              '=' +
              encodeURIComponent(userInput);
        }
      }

      const eachApiPromise = uploadFileWithMetaData(
        hstPath,
        categoryIdToUpload,
        surl,
        csrf,
        imageList[fileIndex]['data_url'],
        imageList[fileIndex].file.name,
        metaValuesParams,
        imageList[fileIndex].file
      );
      // const eachApiPromise = delay(i * 5); //mock an api call test
      fileUploadPromises.push(eachApiPromise);
      eachApiPromise
        .then((res) => {
          if (
            res.status == 200 &&
            res.data.jobs &&
            Array.isArray(res.data.jobs) &&
            res.data.jobs[0].error !== 'T'
          ) {
            const jobData = res.data.jobs[0];
            jobData.job_id, jobData.loader_id;
            setCompletedApiCount((prevCounts) => {
              const updatedCounts = [...prevCounts];
              updatedCounts[fileIndex] = true;
              return updatedCounts;
            });
            fileUploadJobs.push([
              jobData.job_id,
              jobData.loader_id,
              imageList[fileIndex].file.name,
              imageList[fileIndex].fileId,
            ]);
          } else {
            console.error(
              `Error making Upload file API call ${fileIndex + 1}:`,
              res
            );
            setIsUploading(false);
            setIsError(true);
            updateLoadingStatusAt(
              imageList[fileIndex].fileId,
              LOADING_STATUS.FAILED
            );
          }
        })
        .catch((error) => {
          updateLoadingStatusAt(
            imageList[fileIndex].fileId,
            LOADING_STATUS.FAILED
          );
          console.error(
            `Error making Upload file API call ${fileIndex + 1}:`,
            error
          );
          setIsUploading(false);
          setIsError(true);
        });
    });
    await Promise.all(fileUploadPromises);
  };

  const onClickUpdate = async () => {
    setHasTriedSubmitting((prevValue) => prevValue + 1);
    let isFormValid = await validateForm();
    if (!isFormValid) return;
    setIsUploading(true);
    setIsFilesUploaded(false);
    setCompletedApiCount(Array(imageList.length).fill(false));
    setIsAllJobsFinished(Array(imageList.length).fill(false));
    let umoUpdatePromises = [];
    umoLoop: for (let i = 0; i < imageList.length; i++) {
      let metaValuesParams = '';
      const currentFileMeta = metaValues[i]; //metaValues[i] is the metaValues of imageList[i]
      metaValuesLoop: for (let j = 0; j < currentFileMeta.length; j++) {
        const metaName = currentFileMeta[j]?.meta?.name;
        const userInput = currentFileMeta[j]?.meta?.userInput;
        const metaType = currentFileMeta[j]?.meta?.type;
        const metaCategory = currentFileMeta[j]?.meta?.category;

        if (metaType === RGROUP) {
          //RGROUP
          userInput.forEach((group) => {
            group.forEach((tag) => {
              let encodedName = tag.tagName;
              let tagName = encodedName.includes('.')
                ? encodedName
                : metaCategory + '.' + encodedName;
              metaValuesParams =
                metaValuesParams +
                `&META_TAG=${tagName}` +
                '&POSITION_ID=' +
                encodeURIComponent(tag.position) +
                '&VALUE=' +
                encodeURIComponent(tag.userInput);
            });
          });
        }
        //For single repeating input
        else if (Array.isArray(userInput) && userInput.length > 0) {
          userInput.forEach((input, index) => {
            let encodedName = metaName;
            let tagName = encodedName.includes('.')
              ? encodedName
              : metaCategory + '.' + encodedName;
            metaValuesParams =
              metaValuesParams +
              `&META_TAG=${encodeURIComponent(tagName)}` +
              `&POSITION_ID=${index + 1}` +
              `&VALUE=${encodeURIComponent(input)}`;
          });
        } else {
          let encodedName = metaName;
          let tagName = encodedName.includes('.')
            ? encodedName
            : metaCategory + '.' + encodedName;
          metaValuesParams =
            metaValuesParams +
            `&META_TAG=${tagName}` +
            '&POSITION_ID=1' +
            `&VALUE=${encodeURIComponent(userInput)}`;
        }
      }

      const eachApiPromise = updateMetaData(
        hstPath,
        imageList[i].umoId,
        surl,
        csrf,
        metaValuesParams
      );
      // const eachApiPromise = delay(i * 5); //mock an api call test
      umoUpdatePromises.push(eachApiPromise);
      eachApiPromise
        .then((res) => {
          if (res.status == 200) {
            setCompletedApiCount((prevCounts) => {
              const updatedCounts = [...prevCounts];
              updatedCounts[i] = true;
              return updatedCounts;
            });
          } else {
            console.error(`Error making Upload file API call ${i + 1}:`, res);
            setIsUploading(false);
            setIsError(true);
          }
        })
        .catch((error) => {
          console.error(`Error making Upload file API call ${i + 1}:`, error);
          setIsUploading(false);
          setIsError(true);
        });
    }
    try {
      setIsUploading(true);
      await Promise.all(umoUpdatePromises);
      showToast(
        intl.formatMessage({ id: 'fileUploader.metaUpdateSuccess' }),
        TOAST_TYPE.SUCCESS
      );
      setIsUploading(false);
    } catch (error) {
      console.log('Failed to update metadata ~ error:', error);
      showToast(
        intl.formatMessage({ id: 'fileUploader.metaUpdateFail' }),
        TOAST_TYPE.ERROR
      );
      setIsError(true);
    }
  };

  /**
   * Updates isJobFinished boolean flag finding the index using the unique file id
   * @param {string} fileId unique fileId
   */
  const updateIsJobFinshedAt = (fileId) => {
    let fileIndex = null;
    fileIndex = imageList.findIndex((file) => file.fileId == fileId);
    if (fileIndex != null)
      setIsAllJobsFinished((prevState) => {
        const updatedState = [...prevState];
        updatedState[fileIndex] = true;
        return updatedState;
      });
  };

  /**
   * Updates the files loading status finding the index using the unique file id
   * @param {string} fileId unique file id
   * @param {string} status status of the file
   */
  const updateLoadingStatusAt = (fileId, status) => {
    let fileIndex = null;
    fileIndex = imageList.findIndex((file) => file.fileId == fileId);
    if (fileIndex != null)
      setFilesLoadingStatus((prevState) => {
        const updatedState = [...prevState];
        updatedState[fileIndex] = status;
        return updatedState;
      });
  };

  const Link = ({ id, children, title, active, onClick, className }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <Button active={active} onClick={onClick} className={className}>
        {children}
      </Button>
    </OverlayTrigger>
  );

  const copyRow = (actionDirection) => {
    setMetaValues((prevMetaValues) => {
      let tempMetaValues = [...prevMetaValues];
      let rowToCopy = tempMetaValues[onContextFileIndex];
      switch (actionDirection) {
        case COPY_ROW_DOWNWARDS:
          for (let i = onContextFileIndex; i < tempMetaValues.length; i++) {
            tempMetaValues[i] = rowToCopy;
          }
          break;
        case COPY_ROW_UPWARDS:
          for (let i = 0; i <= onContextFileIndex; i++) {
            tempMetaValues[i] = rowToCopy;
          }
          break;
        default:
          for (let i = 0; i < tempMetaValues.length; i++) {
            tempMetaValues[i] = rowToCopy;
          }
          break;
      }
      return tempMetaValues;
    });
  };

  const copyCell = (actionDirection) => {
    setMetaValues((prevMetaValues) => {
      let tempMetaValues = [...prevMetaValues];
      let cellToCopy = tempMetaValues[onContextFileIndex][onContextTagIndex];

      switch (actionDirection) {
        case COPY_CELL_DOWNWARDS:
          for (let i = onContextFileIndex; i < tempMetaValues.length; i++) {
            tempMetaValues[i][onContextTagIndex] = cellToCopy;
          }
          break;
        case COPY_CELL_UPWARDS:
          for (let i = 0; i <= onContextFileIndex; i++) {
            tempMetaValues[i][onContextTagIndex] = cellToCopy;
          }
          break;
        default:
          for (let i = 0; i < tempMetaValues.length; i++) {
            tempMetaValues[i][onContextTagIndex] = cellToCopy;
          }
          break;
      }

      return tempMetaValues;
    });
  };

  const onClickClose = () => {
    dispatch(deselectAll());
    dispatch(showUMOGridNoJView());
    dispatch(showSearchAsMain());
  };

  return (
    <>
      {imageList.length > 0 && (
        <div className="photo-uploader__image-list">
          <ContextMenu
            id="actionMenu"
            hideOnLeave
            style={{ zIndex: 1000, position: 'fixed' }}
            onHide={() => {
              setOnContextFileIndex(null);
              setOnContextTagIndex(null);
            }}
          >
            <CustomContextMenu
              copyCell={copyCell}
              copyRow={copyRow}
              metaValuesLength={metaValues.length}
              onContextFileIndex={onContextFileIndex}
              intl={intl}
            />
          </ContextMenu>
          {/* List Header */}
          {!showMetaEditVersion && (
            <div className="photo-uploader__image-list-header">
              <TextButton
                text={intl.formatMessage({ id: 'general.cancel' })}
                onClick={() => {
                  onImageRemoveAll();
                  setIsDropAreaVisible(true);
                  setMetaValues([]);
                }}
              />
              <div className="font-sm-regular">
                {imageList.length +
                  intl.formatMessage({ id: 'fileUploader.itemsSelected' })}
              </div>
              <div className="photo-uploader__image-list-view-icon-group">
                <ButtonGroup size="sm">
                  <Link
                    active={!isMetaView}
                    onClick={() => setIsMetaView(false)}
                    className="photo-uploader__image-list-view-icon"
                    title={intl.formatMessage({ id: 'fileUploader.fileList' })}
                  >
                    <img src={GridView1} className="umo-toolbar__icon" />
                  </Link>
                  <Link
                    active={isMetaView}
                    onClick={() => setIsMetaView(true)}
                    title={intl.formatMessage({
                      id: 'fileUploader.addMetadata',
                    })}
                    className="photo-uploader__image-list-view-icon"
                  >
                    <img src={ListViewIcon} className="umo-toolbar__icon" />
                  </Link>
                </ButtonGroup>
              </div>
            </div>
          )}
          <div
            className={classNames(
              'photo-uploader__image-list-inner-wrapper',
              showMetaEditVersion &&
                'photo-uploader__image-list-inner-wrapper-full-height',
              isMetaView &&
                'photo-uploader__image-list-inner-wrapper-display-block'
            )}
          >
            {!isMetaView &&
              !showMetaEditVersion &&
              imageList.map((image, index) => (
                <div
                  key={index}
                  className={classNames(
                    'card',
                    'photo-uploader__image-list-item'
                  )}
                >
                  {completedApiCount[index] && (
                    <div className="card-img-top photo-uploader__card-check">
                      <CheckIcon
                        fill="#d45083"
                        width={'24px'}
                        height={'24px'}
                      />
                    </div>
                  )}
                  {isThumbnailAvailable(image) ? (
                    <img
                      className={classNames(
                        'card-img-top',
                        'photo-uploader__card-img',
                        showMetaEditVersion && 'photo-uploader__card-img-me'
                      )}
                      src={getThumbnail(image)}
                      alt="Card image cap"
                      onError={(e) => {
                        e.target.src = './images/thumb/img_nothumb.gif'; //fallback image
                      }}
                    />
                  ) : (
                    <div className="photo-uploader__default-thumbnail">
                      <span className="photo-uploader__default-thumbnail-text">
                        {getFileExtension(image.file.name, false)}
                      </span>
                    </div>
                  )}
                  <div className="card-body photo-uploader__card-body">
                    <h6
                      className="card-title photo-uploader__card-title"
                      title={image.file.name}
                    >
                      {trimFileName(image.file.name, 15)}
                    </h6>
                    <p className="card-text photo-uploader__card-text">
                      {image.file.size ? formatBytes(image.file.size) : ''}
                    </p>
                    <div className="photo-uploader__card-buttons">
                      <div
                        onClick={() => onImageUpdate(index)}
                        className="btn btn-primary mg-right-5"
                      >
                        {intl.formatMessage({ id: 'general.update' })}
                      </div>
                      <div
                        onClick={() => {
                          removeImage(index);
                        }}
                        className="btn btn-primary"
                      >
                        {intl.formatMessage({ id: 'general.remove' })}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            {(isMetaView || showMetaEditVersion) && (
              <Table borderless>
                <thead className="photo-uploader__image-list-fixed-header">
                  <tr>
                    {showMetaEditVersion ? (
                      <th></th>
                    ) : (
                      <th className="photo-uploader__image-list-th font-sm-regular photo-uploader__image-list-view-icon-group photo-uploader__image-list-update-view-icon-group">
                        {metaTags.length > 0 && imageList?.length > 1 && (
                          <ButtonGroup size="sm">
                            <Button
                              active={!isBulkUpload}
                              onClick={() => setIsBulkUpload(false)}
                              className="photo-uploader__image-list-view-icon"
                            >
                              {intl.formatMessage({
                                id: 'metaInput.updateIndividually',
                              })}
                            </Button>
                            <Button
                              active={isBulkUpload}
                              onClick={() => setIsBulkUpload(true)}
                              className="photo-uploader__image-list-view-icon"
                            >
                              {intl.formatMessage({
                                id: 'metaInput.bulkUpdate',
                              })}
                            </Button>
                          </ButtonGroup>
                        )}
                      </th>
                    )}

                    <th className="photo-uploader__image-list-th font-sm-regular">
                      {intl.formatMessage({ id: 'umoListItem.fileName' })}
                    </th>
                    <th className="photo-uploader__image-list-th font-sm-regular">
                      {intl.formatMessage({ id: 'umoListItem.size' })}
                    </th>

                    {metaTags.map((tag, tagIndex) => (
                      <th
                        key={tag.meta.id}
                        className={classNames(
                          'photo-uploader__image-list-th',
                          'font-sm-regular',
                          onContextTagIndex == tagIndex &&
                            'photo-uploader__image-list-th-on-context'
                        )}
                      >
                        {tag.meta.name}
                        {tag.attributes.mandatory == 'T' && (
                          <span className="font-sm-regular "> *</span>
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="photo-uploader__image-list-fixed-column">
                  {imageList.map((image, fileIndex) => {
                    // Determine the base thumbnail URL for the image
                    const baseImageUrl = showMetaEditVersion ? hstPath : '';
                    const defaultImageUrl = './images/thumb/img_nothumb.gif';
                    let imageUrl;
                    if (showMetaEditVersion) {
                      imageUrl = `${baseImageUrl}${image['data_url']}`;
                    } else if (AUDIO_FILE_TYPES.includes(image.file.type)) {
                      imageUrl = './images/thumb/audio.jpg';
                    } else if (VIDEO_FILE_TYPES.includes(image.file.type)) {
                      imageUrl = './images/thumb/video.jpg';
                    } else if (DOCUMENT_FILE_TYPES.includes(image.file.type)) {
                      imageUrl = './images/thumb/document.jpg';
                    } else if (IMAGE_FILE_TYPES.includes(image.file.type)) {
                      imageUrl = `${baseImageUrl}${image['data_url']}`;
                    } else {
                      imageUrl = false;
                    }
                    return (
                      <tr
                        key={`file${fileIndex}`}
                        className={classNames(
                          onContextFileIndex == fileIndex &&
                            'photo-uploader__image-list-row-on-context'
                        )}
                      >
                        <td
                          className={classNames(
                            'photo-uploader__image-list-column',
                            showMetaEditVersion &&
                              'photo-uploader__image-list-column-me'
                          )}
                        >
                          {imageUrl ? (
                            <img
                              className="card-img-top photo-uploader__card-img"
                              src={imageUrl}
                              alt="Card image cap"
                              onError={(e) => {
                                e.target.src = './images/thumb/img_nothumb.gif'; //fallback image
                              }}
                            />
                          ) : (
                            <div className="photo-uploader__default-thumbnail">
                              <span className="photo-uploader__default-thumbnail-text">
                                {getFileExtension(image.file.name, false)}
                              </span>
                            </div>
                          )}
                          <div
                            className={classNames(
                              'photo-uploader__card-buttons',
                              showMetaEditVersion
                                ? 'photo-uploader__card-td-buttons-absolute'
                                : 'photo-uploader__card-td-buttons'
                            )}
                          >
                            {!showMetaEditVersion && (
                              <>
                                <div
                                  onClick={() => onImageUpdate(fileIndex)}
                                  className="btn btn-primary mg-right-5"
                                >
                                  {intl.formatMessage({ id: 'general.update' })}
                                </div>
                                <div
                                  onClick={() => removeImage(fileIndex)}
                                  className="btn btn-primary"
                                >
                                  {intl.formatMessage({ id: 'general.remove' })}
                                </div>
                              </>
                            )}
                            {metaValues.length > 1 && showMetaEditVersion && (
                              <CloseOval
                                width={16}
                                height={16}
                                onClick={() => removeImage(fileIndex)}
                              />
                            )}
                          </div>
                        </td>
                        <td
                          className={classNames(
                            'photo-uploader__image-list-column',
                            showMetaEditVersion &&
                              'photo-uploader__image-list-column-me'
                          )}
                        >
                          {trimFileName(image.file.name, 15)}
                        </td>
                        <td
                          className={classNames(
                            'photo-uploader__image-list-column',
                            showMetaEditVersion &&
                              'photo-uploader__image-list-column-me'
                          )}
                        >
                          {formatBytes(image.file.size)}
                        </td>

                        {!isBulkUpload &&
                          metaValues[fileIndex] &&
                          metaValues[fileIndex].map((tag, tagIndex) => {
                            return (
                              <td
                                key={`${image.file.name}_${tag.meta.id}_${tagIndex}`}
                                className="photo-uploader__image-list-column"
                              >
                                <ContextMenuTrigger
                                  id="actionMenu"
                                  collect={() => {
                                    setOnContextFileIndex(fileIndex);
                                    setOnContextTagIndex(tagIndex);
                                  }}
                                  disable={metaValues.length <= 1}
                                >
                                  <div className="photo-uploader__meta-input">
                                    <MetaInput
                                      fileIndex={fileIndex}
                                      tagIndex={tagIndex}
                                      metaTag={tag}
                                      handleInputChange={handleInputChange}
                                      metaType={tag.meta.type}
                                      userInput={tag.meta.userInput}
                                      key={`${image.file.name}_${tag.meta.id}_${tagIndex}`}
                                      intl={intl}
                                      isMandatory={
                                        tag.attributes.mandatory === 'T'
                                      }
                                      hasTriedSubmitting={hasTriedSubmitting}
                                      imageList={imageList}
                                    />
                                  </div>
                                </ContextMenuTrigger>
                              </td>
                            );
                          })}
                        {isBulkUpload &&
                          fileIndex == 0 &&
                          bulkUploadUserInput[0].map((tag, tagIndex) => (
                            <td
                              className="photo-uploader__meta-input photo-uploader__image-list-column photo-uploader__image-list-sticky-column photo-uploader__image-list-fixed-row"
                              key={image.file.name + tag.meta.id}
                            >
                              <MetaInput
                                fileIndex={0}
                                tagIndex={tagIndex}
                                metaTag={tag}
                                handleInputChange={handleInputChange}
                                metaType={tag.meta.type}
                                userInput={tag.meta.userInput}
                                key={image.file.name + tag.meta.id}
                                intl={intl}
                                isMandatory={tag.attributes.mandatory === 'T'}
                                hasTriedSubmitting={hasTriedSubmitting}
                                imageList={imageList}
                              />
                            </td>
                          ))}
                      </tr>
                    );
                  })}
                  <tr className="photo-uploader__image-list-padding"></tr>
                </tbody>
              </Table>
            )}
          </div>
          {/* Footer */}
          <div
            className={classNames(
              'photo-uploader__image-list-footer',
              showMetaEditVersion &&
                'photo-uploader__image-list-footer-justify-center'
            )}
          >
            {showMetaEditVersion && (
              <>
                <div className="font-sm-regular photo-uploader__image-list-footer-flex1" />
                <div className="font-sm-regular photo-uploader__image-list-footer-flex1">
                  {imageList.length +
                    intl.formatMessage({ id: 'fileUploader.itemsSelected' })}
                </div>
              </>
            )}
            {isTotalFileSizeExceeded && (
              <div className="photo-uploader-margin-right photo-uploader__image-list-info-message">
                <Error fill="#ff0000" />
                {intl.formatMessage(
                  { id: 'fileUploader.addMoreLabel' },
                  { filesize: formatBytes(maxFileSize) }
                )}
              </div>
            )}
            {isUploading && (
              <div className="photo-uploader-margin-right photo-uploader__image-list-info-message">
                <Loader isLarge={true} className="photo-uploader__loader" />{' '}
                {intl.formatMessage({ id: 'fileUploader.uploadingLabel' })}
              </div>
            )}
            {!isUploading && (
              <>
                {!showMetaEditVersion && (
                  <Button
                    onClick={() => {
                      setIsDropAreaVisible(true);
                    }}
                    className="btn btn-primary mg-right-5"
                    disabled={isTotalFileSizeExceeded}
                  >
                    {intl.formatMessage({ id: 'fileUploader.addMoreLabel' })}
                  </Button>
                )}
                <Button
                  onClick={() => {
                    if (showMetaEditVersion) onClickUpdate();
                    else onClickUpload();
                  }}
                  className={classNames(
                    'btn btn-primary',
                    showMetaEditVersion && 'mg-right-5'
                  )}
                  disabled={isTotalFileSizeExceeded}
                >
                  {intl.formatMessage({
                    id: !showMetaEditVersion
                      ? 'umoCardView.uploadButton'
                      : 'general.update',
                  })}
                </Button>
                {showMetaEditVersion && (
                  <Button
                    onClick={() => {
                      onClickClose();
                    }}
                    disabled={isTotalFileSizeExceeded}
                  >
                    {intl.formatMessage({
                      id: 'messageDialog.dismissAllButton',
                    })}
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default injectIntl(FilesList);
